<template>
  <v-container fill-height>
    <v-layout align-center justify-center fill-height>
      <v-flex xs11 sm8 md6 lg4 xl4>
        <v-card flat color="grey lighten-5">
          <v-card-text>
            <div class="text-center">
              <h1>{{ $t("page.maintenanceMode.maintenanceHeader") }}</h1>
            </div>
          </v-card-text>
          <v-card-text>
            <div class="text-center">
              <p>{{ $t("page.maintenanceMode.maintenanceBody") }}{{ maintenance_end }}</p>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data: function() {
    return {
      maintenance_end: process.env.VUE_APP_MAINTENANCE_END
    };
  }
};
</script>